import { ObserversModule } from '@angular/cdk/observers'
import { CommonModule } from '@angular/common'
import { Component, input } from '@angular/core'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'
import { AiPreviewAreaHeaderComponent } from '../preview-area-header/preview-area-header.component'

@Component({
  selector: 'flx-ai-preview-area',
  imports: [CommonModule, AiIconsModule, ObserversModule, AiPreviewAreaHeaderComponent],
  templateUrl: './preview-area.component.html',
  styleUrls: ['./preview-area.component.scss'],
})
export class AiPreviewAreaComponent {
  title = input('')
  hasInfoButton = input(false)
  ignorePadding = input(false)
}
